import { getData, postData } from '@/utils/http'
import config from "@/config"

export default {
    namespaced: true,
    state: {
        tableLoading: true,
        addLoading: false,
        activeItem: null,
        tableList: [],
        // driverTableList: [],
        // carTableList: [],

        //查询条件
        name: '',
        projectId: '',
        code: '',
        status: '4',
        deptId: "",
        goodsType: "",

        pageIndex: 1,
        total: 0,

    },
    mutations: {
        CHANGE_TABLE_LOADING(state, tableLoading) {
            state.tableLoading = tableLoading
        },
        CHANGE_ADD_LOADING(state, addLoading) {
            state.addLoading = addLoading
        },
        CHANGE_TABLE_DATA(state, changeData) {
            state.tableList = changeData.data.rows
            state.total = changeData.total
        },
        CHANGE_ACTIVE_ITEM(state, item) {
            state.activeItem = item
        },
        CHANGE_SEARCH_COLL(state, changeData) {
            if (changeData['changeKey'] == 'orgId' && typeof changeData['data'] != 'object') {
                state[changeData['changeKey']] = [changeData['data']]
            } else {
                state[changeData['changeKey']] = changeData['data']
            }
        },
        CHANGE_TABLE_INDEX(state, value) {
            state.pageIndex = value
        }
    },
    actions: {
        //获取项目列表
        getList({ commit, state }) {
            return new Promise(resolve => {
                getData(`logistics/route/list?projectId=${state.projectId}&name=${state.name}&code=${state.code}&status=${state.status}&page=${state.pageIndex}&size=${config.pageSize}&goodsType=${state.goodsType}`).then(
                    res => {
                        if (res.state == 1) {
                            commit('CHANGE_TABLE_DATA', res)
                            resolve({
                                state: 1,
                                msg: '操作成功'
                            })
                        } else {
                            resolve({
                                state: 0,
                                msg: res.msg
                            })
                        }
                    }
                )
            })
        },

        //获取我的项目列表
        getMyProjectList({ commit, state }, deptId) {
            return new Promise(resolve => {
                getData(`logistics/project/my/list?deptId=${deptId}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            msg: '操作成功',
                            data: res.data
                        })
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg,
                            data: []
                        })
                    }
                })
            })
        },

        getById({ commit, state }) {
            return new Promise(resolve => {
                getData(`logistics/route/get/${state.activeItem.id}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data: res.data,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            data: null,
                            msg: res.msg
                        })
                    }
                })
            })
        },
        //获取驾驶员信息
        getDriverData({ commit, state }, data) {
            return new Promise(resolve => {
                getData(`logistics/driver/get/idle/list2?name=${data.name}&deptId=${data.deptId}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data: res.data,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            data: null,
                            msg: res.msg
                        })
                    }
                })
            })
        },
        //获取车辆信息
        getCarData({ commit, state }, data) {
            return new Promise(resolve => {
                getData(`logistics/car/get/idle/list2?code=${data.code}&carNo=${data.carNo}&deptId=${data.deptId}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data: res.data,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            data: null,
                            msg: res.msg
                        })
                    }
                })
            })
        },


        //获取驾驶员信息
        getDriverDataOut({ commit, state }, data) {
            return new Promise(resolve => {
                getData(`logistics/driver/get/un/idle/list2?name=${data.name}&deptId=${data.deptId}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data: res.data,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            data: null,
                            msg: res.msg
                        })
                    }
                })
            })
        },
        //获取车辆信息
        getCarDataOut({ commit, state }, data) {
            return new Promise(resolve => {
                getData(`logistics/car/get/un/idle/list2?code=${data.code}&carNo=${data.carNo}&deptId=${data.deptId}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data: res.data,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            data: null,
                            msg: res.msg
                        })
                    }
                })
            })
        },
        getAllowOrg({ commit, state }, year) {
            return new Promise((resolve) => {
                getData(`logistics/sys/dept/get/list`).then((res) => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            msg: "操作成功",
                            data: res.data
                        });
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg,
                            data: []
                        });
                    }
                })
            })
        },


        //配置运力
        eidtCapacity({ commit, state }, data) {
            return new Promise(resolve => {
                postData(`logistics/route/trans/update`, data).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg
                        })
                    }
                })
            })
        },


        //配置运力绑定关系
        routeBindTranUpdate({ commit, state }, data) {
            return new Promise(resolve => {
                postData(`logistics/route/bind/trans/update`, data).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            msg: res.msg
                        })
                    }
                })
            })
        },
        
       


        //写入当前操作条目
        setActiveItem({ commit }, item) {
            commit('CHANGE_ACTIVE_ITEM', item)
        },

        //写入查询条件
        setSearchData({ commit }, changeData) {
            commit('CHANGE_SEARCH_COLL', changeData)
        },
        //修改分页
        setPageIndex({ commit }, value) {
            commit('CHANGE_TABLE_INDEX', value)
        },
        //修改添加loading
        changeAddLoading({ commit }, value) {
            commit('CHANGE_ADD_LOADING', value)
        },
        //修改添加loading
        changeListLoading({ commit }, value) {
            commit('CHANGE_TABLE_LOADING', value)
        }
    }
}
